export default "/static/assets/back_btn.9df95f954d2670392d27078e3ddf0eef.svg";